import React from 'react';
import { getCookie } from '../utils/utils';
import './cardStyle.css';
import LongMenu from './LongMenu';

const Card = ({ ridelist, handleModal, isRideStarted }) => {
    const {  name, mobile, user_addr_line1, address, latitude, longitude, status, start_time, end_time, uuid, alternate_phone_number,dialing_code } = ridelist;
    let ph = alternate_phone_number;
    const getStatus = (statusTxt, uuid) => {
        switch (statusTxt) {
            case 'BOOKED':
                return (
                    <button className={`button-two ${isRideStarted ? 'started':''}`} onClick={() => handleModal('start', uuid,ridelist)}>
                        Start
                    </button>
                )
            case 'STARTED':
                return (
                    <button className="button-two end" onClick={() => handleModal('end', uuid)}>
                        End Test Ride
                    </button>
                )
            case 'COMPLETED':
                return (
                    <button className="button-two in-active">
                        Completed
                    </button>
                )
            case 'CANCELLED':
                return (
                    <button className="button-two cancelled">
                        Cancelled
                    </button>
                )
        }
    }
    const convertTime = (time) => {
        function pad(n) {
            return (n < 10 ? '0' : '') + n;
        }
        // note--> Adding 000Z as a standard followed as per time zone, along with this we will be using
        // getTimezoneoffset method which will neglect the time difference of specific time zones...
        var tdate= time;
        if(!time.includes(".000Z")){
             tdate = time+".000Z";
        }
        var date = new Date(new Date(tdate).getTime()+(new Date(tdate).getTimezoneOffset() * 60 * 1000));
        date = (pad(date.getHours()) + ":" + pad(date.getMinutes()));
        var timeString = date;
        var H = +timeString.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? " AM" : " PM";
        timeString = h + timeString.substr(2, 3) + ampm;
        return timeString;
    }
    const openMap = (lat, lng) => {
        handleModal('map',"",ridelist)
       // window.open(`https://www.google.com/maps/search/${lat},${lng}`);
    }
    const getAlternatePhone = (alternate_phone_number) => {
        if (alternate_phone_number !== "") {
            return " Alt Ph:" + alternate_phone_number?.replace(alternate_phone_number.substring(0, 6), '******');
        }
        return "";
    }

    const futDate = localStorage.getItem('futPastDate');
    return (
        <div className="outer-card">
            <div className="inner-head">
                <div className="heading-name">{name}</div>
                {
                        <LongMenu
                            options={["See on map", "Call"]}
                            ITEM_HEIGHT={30}
                            phoneNo={mobile}
                            countryCode={dialing_code}
                            openMap={openMap}
                            latitude={latitude}
                            longitude={longitude}
                        />             
                }
            </div>
            <div className="time-div">
                {convertTime(start_time)} - {convertTime(end_time)}
            </div>
            <div className="address-div">
                {user_addr_line1},{address},
                {
                    status === 'BOOKED' || status === 'STARTED' ? <a href={`tel:${ph}`}>{alternate_phone_number ? getAlternatePhone(alternate_phone_number) : null}</a> : null
                }
            </div>
            <div>
                {new Date(futDate) <= new Date() ? getStatus(status, uuid) : null}
            </div>
        </div>

    )
}

export default Card;
